import React from "react";
import { QueryObject, SubQueryInterface } from "../ListBuildertypes";

interface FiltersPreviewProps {
   queryObject: QueryObject;
   onRemoveProperty: (fieldName: string) => void;
   onRemoveSubQuery: (path: string[]) => void; // path do filtra w subQuery
}

const FiltersPreview: React.FC<FiltersPreviewProps> = ({
   queryObject,
   onRemoveProperty,
   onRemoveSubQuery,
}) => {
   const collectSubQueryLines = (
      subQuery: SubQueryInterface,
      path: string[] = [],
   ): { line: string; path: string[] }[] => {
      const currentPath = [...path, subQuery.parentProperty];
      const lines: { line: string; path: string[] }[] = [];

      if (subQuery.properties) {
         Object.entries(subQuery.properties)
            .filter(([_, value]) => value !== undefined && value !== "")
            .forEach(([key, value]) => {
               lines.push({
                  line: `${currentPath.join(" -> ")} -> ${key} = ${value}`,
                  path: [...currentPath, key], // przechowujemy path do konkretnego pola
               });
            });
      }

      if (Array.isArray(subQuery.subQueries)) {
         subQuery.subQueries.forEach((child) => {
            lines.push(...collectSubQueryLines(child, currentPath));
         });
      }

      return lines;
   };
   return (
      <div style={{ display: "flex", flexDirection: "column", marginTop: "5px" }}>
         {/* zwykłe properties */}
         {Object.entries(queryObject?.properties ?? {})
            .filter(([_, value]) => value !== undefined && value !== null)
            .map(([fieldName, fieldValue]) => (
               <div
                  key={fieldName}
                  style={{
                     border: "none",
                     backgroundColor: "#bbdd40",
                     width: "300px",
                     padding: "5px",
                     borderRadius: "5px",
                     marginBottom: "5px",
                     display: "flex",
                     justifyContent: "space-between",
                     alignItems: "center",
                  }}
               >
                  <span>
                     {fieldValue.label} = {fieldValue.techName}
                  </span>
                  <span
                     onClick={() => onRemoveProperty(fieldName)}
                     className="material-symbols-outlined"
                     style={{ cursor: "pointer" }}
                  >
                     delete
                  </span>
               </div>
            ))}

         {/* subQueries */}
         {queryObject.subQueries.flatMap((sq, index) =>
            collectSubQueryLines(sq).map(({ line, path }, i) => (
               <div
                  key={`${index}-${i}`}
                  style={{
                     marginTop: "5px",
                     border: "none",
                     backgroundColor: "#bbdd40",
                     width: "300px",
                     padding: "5px",
                     borderRadius: "5px",
                     display: "flex",
                     justifyContent: "space-between",
                     alignItems: "center",
                  }}
               >
                  <span>{line}</span>
                  <span
                     onClick={() => onRemoveSubQuery(path)}
                     className="material-symbols-outlined"
                     style={{ cursor: "pointer" }}
                  >
                     delete
                  </span>
               </div>
            )),
         )}
      </div>
   );
};

export default FiltersPreview;
